import React from 'react';
import moment from 'moment';
import { Calendar, ArrowRight, FileText, Eye, Users } from 'lucide-react';
import KpiBar, { KpiCard } from '../../../../../../shared/designSystem/components/KpiBar';
import { formatDateOnly } from '../../../../../../shared/designSystem/utils/dateFormat';
import { formatWholeNumber } from '../../../../../../../core/utils/campaigns';

const flightProgress = (startDate, endDate) => {
  const total = moment(endDate).diff(moment(startDate), 'days');
  const progress = moment().diff(moment(startDate), 'days');
  if (total <= 0 || progress <= 0) return 0;
  if (progress >= total) return 100;
  return Math.floor((progress / total) * 100);
};

const DetailBar = ({ pageViews, impressions, uniqueUsers, startDate, endDate }) => {
  const progressPercent = flightProgress(startDate, endDate);

  return (
    <KpiBar>
      <div className="campaign-overview__kpi">
        <div className="campaign-overview__kpi-head">
          <span className="campaign-overview__kpi-icon campaign-overview__kpi-icon--neutral">
            <Calendar size={16} />
          </span>
          <span className="campaign-overview__kpi-eyebrow">Flight Dates</span>
        </div>
        <div className="campaign-overview__flight">
          <div className="campaign-overview__flight-dates">
            <span>{formatDateOnly(startDate, '—')}</span>
            <ArrowRight size={14} className="campaign-overview__flight-arrow" />
            <span>{formatDateOnly(endDate, '—')}</span>
          </div>
          <div className="campaign-overview__flight-progress">
            <div
              className="campaign-overview__flight-progress-bar"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <div className="campaign-overview__flight-meta">
            {progressPercent}% elapsed
          </div>
        </div>
        <div className="campaign-overview__kpi-footer" />
      </div>

      <KpiCard
        icon={<FileText size={16} />}
        iconTint="primary"
        label="Page Views"
        value={formatWholeNumber(pageViews)}
      />
      <KpiCard
        icon={<Eye size={16} />}
        iconTint="sky"
        label="Impressions"
        value={formatWholeNumber(impressions)}
      />
      <KpiCard
        icon={<Users size={16} />}
        iconTint="indigo"
        label="Unique Users"
        value={formatWholeNumber(uniqueUsers)}
      />
    </KpiBar>
  );
};

export default DetailBar;
